

































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import { userModule } from "@/store/modules/user";
import ResepObatSvc from "@/services/ResepObat";
import { orderBmhpStore } from "@/store/modules/OrderBmhp";
import { appModule } from "@/store/modules/app";
import BmhpItemRow from "@/components/pemeriksaan/resep-obat/BmhpItemRow.vue";

@Component({
  components: {
    BmhpItemRow
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class OrderBmhpInputCard extends Vue {
  items = [];
  @Prop() order;
  @Prop() show;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  saving = false;
  sending = false;
  removing = false;
  showOrderBmhpInput = false;

  orderId = null;
  depoId = "03";
  pasienRm = null;
  tanggal = moment().format("yyyy-mm-dd");

  get orderInput() {
    return {
      id: this.orderId,
      depo_id: this.depoId,
      bb: null,
      alergi: null,
      diagnosis: null,
      user_id: userModule.user.id,
      unit_id: userModule.user.unit_id,
      pasien_cm: this.pasienRm,
      register_id: this.register,
      tanggal: this.tanggal,
      status: "1",
      items: this.items,
      kategori: "a"
    };
  }

  get register() {
    return this.$route.params.register;
  }

  get isSent() {
    return this.order?.status >= 1;
  }

  addItem() {
    this.items.push({
      id: null,
      obat_id: null,
      obat_nama: null,
      qty: null,
      qty_unit: null,
      harga: null,
      countedHarga: null,
      ap_dosis: null,
      ap_tambahan: null,
      ap_template_id: null,
      ap_template_nama: null,
      frekuensi_id: null,
      rute_id: null,
      r: null,
      stopped_at: null
    });
  }

  get invalidField() {
    const inv = this.orderInput.items
      .map((item, idx) => {
        if (!item.obat_id || !item.qty) {
          return idx;
        }
      })
      .filter(item => item !== null && item !== undefined);

    return inv;
  }

  get invalidFieldWarning() {
    const warn = this.invalidField
      .map(item => {
        return `kolom ke-${item + 1}`;
      })
      .join(", ")
      .replace(/, ([^,]*)$/, " dan $1");

    return warn ? `${warn} ada yang kosong. Lengkapi dulu!` : "";
  }

  validateItems() {
    if (this.invalidFieldWarning) {
      alert(this.invalidFieldWarning);
      return false;
    } else {
      return true;
    }
  }

  saveOrder() {
    if (!this.validateItems()) {
      return false;
    }

    if (!this.saving) {
      this.saving = true;

      const endPoint = this.orderId
        ? ResepObatSvc.update(this.orderId, this.orderInput)
        : ResepObatSvc.create(this.orderInput);

      endPoint
        .then(async response => {
          if (response.data.status == 1) {
            const notice = this.orderId
              ? "Berhasil mengubah resep!"
              : "Berhasil membuat resep!";
            appModule.sendSuccessNotice(notice);
            appModule.closeNoticeWithDelay();

            await this.sendOrder(response.data.data.id);
            await this.sendOrder(response.data.data.id);

            // orderBmhpStore.getOrderByRegister(this.register);

            this.closeOrderInput();
          }
        })
        .catch(err => {
          // this.showErrorAlert(err);
        })
        .then(() => {
          this.saving = false;
        });
    }
  }

  removeOrder() {
    const q = confirm("Anda yakin akan menghapus order ini?");

    if (q && !this.removing) {
      this.removing = true;

      ResepObatSvc.remove(this.orderId)
        .then(resp => {
          if (resp.data.status == 1) {
            appModule.sendSuccessNotice("Berhasil menghapus order");
            appModule.closeNoticeWithDelay();

            this.closeOrderInput();

            orderBmhpStore.getOrderByRegister(this.register);
          }
        })
        .finally(() => {
          this.removing = false;
        });
    }
  }

  async sendOrder(id) {
    if (!this.sending) {
      this.sending = true;

      ResepObatSvc.sendResep(id)
        .then(resp => {
          if (resp.data.status == 1) {
            appModule.sendSuccessNotice("Berhasil mengirim order");
            appModule.closeNoticeWithDelay();

            // this.order.status = 1;

            orderBmhpStore.getOrderByRegister(this.register);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }

  async unsendOrder(id) {
    if (!this.sending) {
      this.sending = true;

      ResepObatSvc.undoSend(id)
        .then(resp => {
          if (resp.data.status == 1) {
            appModule.sendSuccessNotice("Berhasil membatalkan kiriman order");
            appModule.closeNoticeWithDelay();

            // this.order.status = 0;

            orderBmhpStore.getOrderByRegister(this.register);
          }
        })
        .finally(() => {
          this.sending = false;
        });
    }
  }

  removeItem(idx) {
    this.items.splice(idx, 1);
  }

  closeOrderInput() {
    this.items = [];
    this.$emit("close");
  }

  mounted() {
    this.orderId = null;
    this.pasienRm = this.$route.params.rm;
    this.depoId = "03";
    this.tanggal = moment().format("YYYY-MM-DD");

    this.items = [];
  }

  @Watch("show")
  changeShow(val) {
    // if (!val) {
    //   this.order = null;
    // }
    // console.log("change show", this.order);
  }

  @Watch("order")
  changeOrder(val) {
    this.items = [];

    if (val) {
      this.orderId = val.id;
      this.pasienRm = val.pasien.cm;
      this.depoId = val.depo_id;
      this.tanggal = val.tanggal;

      this.items = val.items.map(item => {
        item.frekuensi_id = item.frekuensi?.id ?? null;
        item.rute_id = item.rute?.id ?? null;
        return item;
      });
    } else {
      this.orderId = null;
      this.pasienRm = this.$route.params.rm;
      this.depoId = "03";
      this.tanggal = moment().format("YYYY-MM-DD");
    }

    console.log("change order", {
      orderId: this.orderId,
      pasienRm: this.pasienRm,
      depoId: this.depoId,
      tanggal: this.tanggal,
      items: this.items
    });
  }

  onEventTab(idx) {
    console.log("emit tab.....");
    if (this.items.length == idx + 1) {
      this.addItem();
    }
  }
}
